import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-amortization-table',
  templateUrl: './amortization-table.component.html',
  styleUrls: ['./amortization-table.component.scss'],
  standalone: false,
})
export class AmortizationTableComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
